<template>
  <v-container fluid class="scenario-step-container pa-0">
    <v-row class="tab-row ma-0">
      <v-col cols="12" class="d-flex px-0">
        <div class="step-tab-scope d-flex flex-column w-100">
          <v-tabs data-id-e2e="tabsStep" class="step-tabs" density="compact" :hide-slider="true">
            <v-tab
              v-for="tab in tabs"
              :key="tab.routeName"
              :disabled="tab.disabled"
              class="step-tab justify-space-between"
              :to="{
                name: tab.routeName,
                params: {
                  scenarioId: selectedScenario._id,
                },
                query: $route.query,
              }"
              :replace="tab.replaceInHistory"
            >
              <span class="tab-title">{{ $t(tab.translationKey) }}</span>

              <div class="step-tab__status">
                <span v-if="tab.lastUpdated" class="tab-last-updated"
                  >{{ $t('general.updated') }}:
                  {{ formatDate(tab.lastUpdated, getDateFormats.medium) }}</span
                >
                <span v-if="tab.status && !tab.hideStatus" class="tab-icon">
                  <v-icon v-if="showStatuses" size="small">${{ tab.status }} </v-icon>
                </span>
              </div>
            </v-tab>
          </v-tabs>
          <router-view :key="selectedScenario._id" :data-id-e2e="`${$route.name}-tab-page`" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import tabUtils from '@/utils/tabs/tabs-utils';
import { get } from 'lodash';
import { mapState } from 'pinia';

// Stores
import { useDayjs } from '@/composables/use-dayjs';
import { useContextStore } from '@/stores/context';
import { useScenariosStore } from '@/stores/scenarios';
import { useWorkpackagesStore } from '@/stores/workpackages';

export default {
  props: {
    step: {
      required: true,
      type: String,
    },

    tabData: {
      required: true,
      type: Object,
    },

    showStatuses: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup() {
    const { formatDate } = useDayjs();

    return { formatDate };
  },
  data() {
    return {};
  },

  computed: {
    ...mapState(useScenariosStore, ['selectedScenario', 'selectedScenarioStatus']),
    ...mapState(useWorkpackagesStore, ['selectedWorkpackage', 'selectedWorkpackageStatus']),
    ...mapState(useContextStore, ['getDateFormats', 'getClientConfig']),

    selectedTab() {
      return this.enabledTabs.find(item => item.routeName === this.$route.name);
    },

    enabledTabs() {
      return tabUtils.getAllEnabledTabs(this.tabData.ALL, this.getClientConfig);
    },

    tabs() {
      // Get the base tab data
      const tabLayoutData = tabUtils.getByStepAndType(
        this.tabData.ALL,
        this.step,
        this.selectedWorkpackage.type,
        this.getClientConfig
      );

      // Add the scenario status
      // TODO - Disabling tabs works, but not if you change scenario from the drop down.
      // Need to discuss strategy for this
      tabLayoutData.forEach(tab => {
        const statusSection =
          get(this.selectedScenarioStatus, tab.statusSection) ||
          get(this.selectedWorkpackageStatus, tab.statusSection);

        if (statusSection && statusSection[tab.statusSubSection]) {
          tab.lastUpdated = statusSection[tab.statusSubSection].lastModifiedDate;
          tab.status = statusSection[tab.statusSubSection].status;
          tab.disabled = !statusSection[tab.statusSubSection].available;
        } else {
          tab.lastUpdated = null;
          tab.status = null;
          tab.disabled = false;
        }
      });

      return tabLayoutData;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.scenario-step-container {
  height: 100%;
  flex: 1;
}

.tab-row {
  height: 100%;
}

.toolbar-space {
  margin-bottom: 20px;
}

.step-tab-scope {
  // TODO subtracting 18px here to avoid actions overflowing the bar.
  // Should be properly fixed through better layout.
  height: calc(100% - 18px);

  .v-tabs-bar__content :first-child:not(.tab-last-updated) {
    margin-left: 0px !important;
  }

  .step-tab {
    padding: 0 10px;
    justify-content: inherit;
    text-align: inherit;
    text-transform: none;
    min-width: 200px;
    border: 0.3px solid $assortment-border-colour;
    border-left: 3px solid $assortment-border-colour;
    border-bottom: none;
    font-size: 13px;
    font-weight: 900;
    color: $assortment-inactive-tab-text-colour !important; // non-selected tab should be slightly faded

    &:not(:first-child) {
      margin-left: 4px;
    }

    .step-tab__status {
      display: flex;
      align-items: center;
    }

    .tab-last-updated {
      font-size: 11px;
      font-weight: 400;
      margin-left: 30px;
    }

    .tab-icon {
      float: right;
      margin-left: 4px;
    }
  }

  .step-tabs.theme--light.v-tabs > .v-tabs-bar {
    background-color: inherit !important;
  }

  .v-tabs-bar {
    height: 37px;
  }

  .v-tab--selected {
    background-color: #ffffff;
    color: $assortment-text-colour !important;
  }

  .v-tab.v-tab {
    color: $assortment-text-colour;
  }

  .v-tabs-slider {
    background-color: #ffffff;
  }
}
</style>
